import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-operation-create-payment",
  "use": "icon-operation-create-payment-usage",
  "viewBox": "0 0 19 19",
  "content": "<symbol viewBox=\"0 0 19 19\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-operation-create-payment\">\n<path d=\"M14 17.22H2V5H9V3H2C0.9 3 0 3.9 0 5V17C0 18.1 0.9 19 2 19H14C15.1 19 16 18.1 16 17V10H14V17.22Z\" fill=\"#98A1B4\" />\n<path d=\"M16 0H14V3H11C11.01 3.01 11 5 11 5H14V7.99C14.01 8 16 7.99 16 7.99V5H19V3H16V0Z\" fill=\"#98A1B4\" />\n<path d=\"M12 7H4V9H12V7Z\" fill=\"#98A1B4\" />\n<path d=\"M4 10V12H12V10H9H4Z\" fill=\"#98A1B4\" />\n<path d=\"M12 13H4V15H12V13Z\" fill=\"#98A1B4\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol